import { envConfig } from '@headless-workspace/config';
import { ApiError } from '@headless-workspace/data';
import { promises as fs } from 'fs';

type ReadStorageFileParams = {
    directory: string;
    fileName: string;
};

const STORAGE_ERROR_CODE = 'STORAGE_FILES_ERROR';
const DEFAULT_STORAGE_ERROR_MESSAGE = 'Error reading storage files';

export const readStorageFile = async ({ directory, fileName }: ReadStorageFileParams): Promise<unknown | null> => {
    try {
        const filePath = `${envConfig.storageBasePath}/${directory}/${fileName}`;

        const file = await fs.readFile(filePath);

        return JSON.parse(file.toString());
    } catch (error) {
        // File not found error handling
        if ((error as NodeJS.ErrnoException).code === 'ENOENT') {
            return null;
        }

        throw new ApiError(500, {
            errors: [
                {
                    errorCode: STORAGE_ERROR_CODE,
                    errorMessage: error instanceof Error ? error.message : DEFAULT_STORAGE_ERROR_MESSAGE,
                },
            ],
        });
    }
};
